import React, { useState, useContext } from "react";
import AuthContext from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import "./Register.css";

const Register = () => {
  const { registerUser, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [telefone, setTelefone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isBuyer, setIsBuyer] = useState(true);
  const [formErrors, setFormErrors] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors([]);

    const newErrors = [];

    if (password !== confirmPassword) {
      newErrors.push("As senhas não coincidem.");
    }

    if (newErrors.length > 0) {
      setFormErrors(newErrors);
      return;
    }

    try {
      await registerUser(
        email,
        username,
        telefone,
        password,
        confirmPassword,
        isBuyer
      );
      navigate("/");
    } catch (err) {
      console.error("Erro no registro:", err);

      if (err.response && err.response.data) {
        const data = err.response.data;
        const errorMessages = [];

        for (const field in data) {
          if (Array.isArray(data[field])) {
            data[field].forEach((msg) => {
              errorMessages.push(`${field}: ${msg}`);
            });
          } else {
            errorMessages.push(`${field}: ${data[field]}`);
          }
        }

        // Tradução de nomes dos campos
        const traducaoCampos = {
          email: "Email",
          username: "Nome de usuário",
          telefone: "Telefone",
          password: "Senha",
          confirmPassword: "Confirmação de senha",
          isBuyer: "Tipo de usuário",
          non_field_errors: "Erro"
        };

        // Tradução de mensagens específicas
        const traducoesEspecificas = {
          "user with this email already exists.": "Já existe um usuário com este email.",
          "user with this username already exists.": "Já existe um usuário com este nome de usuário.",
          "this field may not be blank.": "Este campo não pode estar em branco.",
          "enter a valid email address.": "Digite um endereço de email válido."
        };

        const mensagensTraduzidas = errorMessages.map((msg) => {
          let [campo, ...resto] = msg.split(":");
          campo = campo.trim().toLowerCase();
          let mensagem = resto.join(":").trim();

          // Traduz mensagem se for conhecida
          const msgTraduzida =
            traducoesEspecificas[mensagem.toLowerCase()] || mensagem;

          // Traduz campo, se aplicável
          const campoTraduzido =
            traducaoCampos[campo] || campo.charAt(0).toUpperCase() + campo.slice(1);

          return `${campoTraduzido}: ${msgTraduzida}`;
        });

        setFormErrors(mensagensTraduzidas);
      } else {
        setFormErrors(["Erro ao registrar o usuário. Tente novamente mais tarde."]);
      }
    }
  };

  return (
    <div>
      <h2 className="principal">Registrar-se</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Nome de usuário:</label>
          <input
            type="text"
            value={username}
            placeholder="Exemplo: Paulo"
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Telefone:</label>
          <input
            type="text"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Senha:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Confirmar Senha:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        {/* Exibir erros por linha */}
        {formErrors.length > 0 && (
          <div style={{ color: "red", marginTop: "10px" }}>
            {formErrors.map((error, index) => (
              <div key={index}>{error}</div>
            ))}
          </div>
        )}

        <div>
          <button type="submit" disabled={loading}>
            {loading ? "Registrando..." : "Registrar"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Register;
